/**
 * GAP 5b — the advisory report as a hook. Self-sources the shared compile and
 * memoizes {@link computeAdvisoryFindings}; the `AdvisoryPane` renders the result
 * in the details/inspector area. Empty (the pane hides) unless the workspace
 * declares advisory-severity policy findings.
 */
import { useMemo } from "react";
import { useWorkspaceModel } from "../workbench/WorkspaceModelContext.js";
import { computeAdvisoryFindings, type AdvisoryEntry } from "./advisoryReport.js";

export function useAdvisoryFindings(): readonly AdvisoryEntry[] {
  const { resolvedModel, graph, compiledSources } = useWorkspaceModel();
  return useMemo(
    () => computeAdvisoryFindings(resolvedModel, graph, compiledSources),
    [resolvedModel, graph, compiledSources],
  );
}
